import { Component, Input, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class TabComponent {
  @Input() title: string;
  @Input() id: string;
  @Input() active = false;
  @Input() disabled;
  @Input() doCheck;
}
